const isValid = (arr) => {
  return arr != null && arr.length > 0
}

export default isValid
